module.exports = __webpack_public_path__ + "static/media/roo_wor_edg_pro.859b1526.png";